module.exports = __webpack_public_path__ + "static/img/hoverlogo05.9b96c489.png";